module.exports = __webpack_public_path__ + "static/media/calendarSvgIcon.07927e41.svg";